<template>
	<fieldset class="itv-input-text">
		<label
			v-if="label"
			class="itv-input-text__label"
			:for="`${id}-${formCode}`"
		>
			{{ label }}
		</label>
		<div class="itv-input-text__field-wrap">
			<div class="itv-input-text__icon">
				<slot></slot>
			</div>
			<input
				class="itv-input-text__field"
				:class="{ 'js--phone-mask': type === 'tel' }"
				:type="type"
				:id="`${id}-${formCode}`"
				:name="name"
				:placeholder="placeholder"
				v-model="value"
				autocomplete="off"
				:ref="id"
				@input="handler"
				:maxlength="type === 'tel' ? 17 : 100"
			/>
			<div v-if="value" class="itv-input-text__clear">
				<btn-clear @click-event="clearField" />
			</div>
		</div>
	</fieldset>
</template>

<script>
import BtnClear from './BtnClear'
import phoneMask from '@/js/modules/phone-mask'

export default {
	name: 'InputText',
	components: {
		BtnClear,
	},
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		formCode: {
			type: String,
			default: 'form',
		},
		id: {
			type: String,
			default: 'text',
		},
		paramName: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			value: '',
		}
	},
	methods: {
		handler() {
			this.$emit('changeValue', this.value, this.id)
		},
		clearField() {
			if (event.target.classList.contains('itv-btn-clear')) return
			this.value = ''
			this.$emit('changeValue', this.value, this.id)
		},
	},
	created() {
		if (!this.paramName) return
		this.value = new URLSearchParams(window.location.search).get(this.paramName)
		this.$emit('changeValue', this.value, this.id)
	},
	mounted() {
		if (this.type === 'tel')
			phoneMask(document.querySelectorAll('.js--phone-mask'))
	},
}
</script>
